/**
 * 老师时间重叠校验工具
 * 用于校验买断时间、短期固定时间、上课时间之间是否有重叠
 */

const weekZh = ['周日', '周一', '周二', '周三', '周四', '周五', '周六', '周日']

/**
 * 两个时间范围是否交叉
 */
function hasTimeOverlap (s1, e1, s2, e2) {
  return (s1 < e2) && (e1 > s2)
}

/**
 * 从 Unix 时间戳(秒) 获取星期几 (1=Mon, 7=Sun)
 */
function getWeekFromTimestamp (ts) {
  const date = new Date(ts * 1000)
  const day = date.getDay()
  return day === 0 ? 7 : day
}

/**
 * 两个 slot 是否在同一天/同一 weekday
 */
function isSameDay (slot1, slot2) {
  if (slot1.week != null && slot2.week != null) {
    return slot1.week === slot2.week
  }
  if (slot1.day != null && slot2.day != null) {
    return slot1.day === slot2.day
  }
  if (slot1.week != null && slot2.day != null) {
    return slot1.week === getWeekFromTimestamp(slot2.day)
  }
  if (slot1.day != null && slot2.week != null) {
    return getWeekFromTimestamp(slot1.day) === slot2.week
  }
  return false
}

/**
 * 格式化 slot 为可读字符串
 */
function formatSlot (slot) {
  const dayLabel = slot.weekStr || slot.dayStr || (slot.week != null ? weekZh[slot.week] : '')
  const start = slot.startTimeStr || ''
  const end = slot.endTimeStr || ''
  return `${dayLabel} ${start}-${end}`
}

/**
 * 校验新增时间列表是否与已有时间冲突
 * @param {Array} newSlots - 本弹窗提交的时间列表
 * @param {Array} existingOpened - 已有买断时间列表
 * @param {Array} existingShortTerm - 已有短期固定时间列表
 * @param {Array} existingRandom - 已有上课时间列表
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validateSlots (newSlots, existingOpened, existingShortTerm, existingRandom) {
  const errors = []

  if (!newSlots || newSlots.length === 0) {
    return { valid: true, errors: [] }
  }

  // 新时间之间互相比对
  for (let i = 0; i < newSlots.length; i++) {
    for (let j = i + 1; j < newSlots.length; j++) {
      if (isSameDay(newSlots[i], newSlots[j]) &&
          hasTimeOverlap(newSlots[i].startTime, newSlots[i].endTime,
            newSlots[j].startTime, newSlots[j].endTime)) {
        errors.push('新增时间内部重叠: ' + formatSlot(newSlots[i]) + ' 与 ' + formatSlot(newSlots[j]))
      }
    }
  }

  // 与已有买断时间比对
  checkAgainstExisting(newSlots, existingOpened, '买断时间', errors)

  // 与已有短期固定时间比对
  checkAgainstExisting(newSlots, existingShortTerm, '短期固定时间', errors)

  // 与已有上课时间比对
  checkAgainstExisting(newSlots, existingRandom, '上课时间', errors)

  return {
    valid: errors.length === 0,
    errors
  }
}

function checkAgainstExisting (newSlots, existingSlots, typeName, errors) {
  if (!existingSlots || existingSlots.length === 0) return
  for (const newSlot of newSlots) {
    for (const existing of existingSlots) {
      if (isSameDay(newSlot, existing) &&
          hasTimeOverlap(newSlot.startTime, newSlot.endTime,
            existing.startTime, existing.endTime)) {
        errors.push(`与${typeName}冲突: ` + formatSlot(existing))
        return // 当前新slot已有冲突，检查下一个
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/timeSlotValidator.js